// extracted by mini-css-extract-plugin
export default {"contact":"_d3c52efd","desktop":"_82857a8f","tablet":"_112e117","emailLink":"_7f5f911"};